// extracted by mini-css-extract-plugin
export default {"container":"normal_container__GIaFe","boxContainer":"normal_boxContainer__z9t2S"};